export default "__VITE_ASSET__CxR37AXI__"